import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7.923 18.985c0 5.414 4.372 9.787 9.775 9.787a9.765 9.765 0 0 0 9.776-9.787c0-5.424-4.286-9.732-9.69-9.732-.376 0-.752.043-1.085.097l2.138-2.095c.236-.247.376-.526.376-.902 0-.763-.59-1.375-1.332-1.375-.376 0-.688.14-.935.397l-4.383 4.469c-.29.268-.44.623-.44.999 0 .386.15.709.44.999l4.383 4.447c.237.236.548.365.935.365.741 0 1.332-.59 1.332-1.342 0-.377-.14-.656-.376-.892l-2.417-2.396c.397-.075.87-.107 1.364-.107 3.878 0 6.918 3.105 6.918 7.068A6.994 6.994 0 0 1 17.698 26a7.003 7.003 0 0 1-7.014-7.015c0-.837-.559-1.418-1.354-1.418-.827 0-1.407.58-1.407 1.418"
	})
});
export default SvgIcoRefresh;
